// src/utils/bus.js
import mitt from 'mitt';

const bus = mitt(); // 创建事件总线实例
export default bus;